import React from 'react';

const CSS = require('./LastUsedToolTip.module.scss');

interface LastUsedToolTipProps {
  variant: 'oauth' | 'login';
}

function LastUsedToolTip({ variant }: LastUsedToolTipProps) {
  return (
    <span className={CSS.LastUsedToolTip} data-variant={variant}>
      Last used
    </span>
  );
}

export default LastUsedToolTip;
